import { Component } from '@angular/core';
import { faWrench } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-dropdown-list-icon',
  templateUrl: './dropdown-list-icon.component.html',
  styleUrls: ['./dropdown-list-icon.component.sass'],
})
export class DropdownListIconComponent {
  readonly faSetting = faWrench;
}
